module.exports = __webpack_public_path__ + "static/img/cabecera1.231bd81a.jpg";